import React from "react";

type RowProps = { children: React.ReactNode };

const Row = ({ children }: RowProps) => (
  <div className="h-full flex flex-wrap">{children}</div>
);

export default Row;
